/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Faq_Q3Inputs */

const en_pc_online_faq_q3 = /** @type {(inputs: Pc_Online_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why is the first load slow?`)
};

const zh_pc_online_faq_q3 = /** @type {(inputs: Pc_Online_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么首次加载比较慢？`)
};

/**
* | output |
* | --- |
* | "Why is the first load slow?" |
*
* @param {Pc_Online_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_faq_q3 = /** @type {((inputs?: Pc_Online_Faq_Q3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Faq_Q3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_faq_q3(inputs)
	return zh_pc_online_faq_q3(inputs)
});
export { pc_online_faq_q3 as "pc.online.faq.q3" }